package com.anjuros.website.redesign.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.styles.RdClosingButtonsStyle
import com.anjuros.website.redesign.styles.RdClosingStyle
import com.anjuros.website.redesign.styles.RdGhostButtonOnDarkStyle
import com.anjuros.website.redesign.styles.RdH2Style
import com.anjuros.website.redesign.styles.RdHeroCopyStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Text

/** Dark call-to-action card at the end of a page: a free preview plus one secondary link. */
@Composable
fun RdClosingCard(
    eyebrow: RdText,
    title: RdText,
    lede: RdText,
    secondaryText: RdText,
    secondaryPath: String,
) {
    RdSection(id = "close", labelledBy = "close-h") {
        Div(RdClosingStyle.toModifier().toAttrs()) {
            Div(RdHeroCopyStyle.toModifier().toAttrs()) {
                RdEyebrow(eyebrow)
                H2(RdH2Style.toModifier().id("close-h").toAttrs()) { Text(LocalText(title)) }
                RdLede(lede)
            }
            Div(RdClosingButtonsStyle.toModifier().toAttrs()) {
                RdPrimaryButton(RdRoute.CONTACT, RdText.CTA_FREE_PREVIEW)
                RdGhostButton(secondaryPath, secondaryText, withArrow = true, modifier = RdGhostButtonOnDarkStyle.toModifier())
            }
        }
    }
}
